import React from 'react';
import {action, computed, observable, createTransformer} from 'mobx';
import {observer, inject} from 'mobx-react';
import {Decorator as editable} from 'simbox-editable';
import autoclass from 'autoclass-decorator';
import BaseViewStore from 'base-viewstore';
import BaseComponent from 'base-component';

/**
 * A course of action component presents one or more selections and users choose one of the selections.
 * At any time, only one action is visible.
 * Zero or one of the selections may be selected.
 * Selections can have criteria: choices that users make to further describe why they choose a particular action.
 */

export class CourseOfActionViewStore extends BaseViewStore {
  currentTabIndex = 0;
  currentSelectionTabIndex = 10000;

  get nextTabIndex() {
    return ++this.currentTabIndex;
  }

  get nextSelectionTabIndex() {
    return ++this.currentSelectionTabIndex;
  }

  @observable visibleAction = 0;
  @observable optionValues = {};

  @computed get invalid() {
    return {};
  }

  @computed get selectedAction() {
    const {
      contentModel,
    } = this.props;

    const action = contentModel.getInput('selectedActionIndex');
    return action;
  }

  @action.bound
  updateUserInput(val) {
    const {
      contentModel
    } = this.props;

    // this updates user input property `userInput`, defined on the contentModel
    contentModel.updateInput("userInput", val)
  }

  @action.bound
  save() {
    alert("This will save user input")
  }


  @action.bound
  showAction(index) {
    this.visibleAction = index;
  }

  @action.bound
  selectAction() {
    const {
      contentModel,
    } = this.props;

    contentModel.setInput('selectedActionIndex', this.visibleAction);
    contentModel.saveInputs(() => console.info('Selected COA Action'));
  }
}

@autoclass
@editable
@observer
export class CourseOfAction extends BaseComponent {

  static ViewStore = CourseOfActionViewStore;

  componentWillMount() {
  }

  render() {
    const {
      contentModel
    } = this.props;

    const {
      selections,
      criteriaTitle,
      introText,
    } = contentModel; // this contentModel's properties

    const {
      visibleAction,
      showAction,
      selectAction,
      selectOption,
      selectedAction,
      optionValue,
    } = this.viewStore; // this components viewStore.  Will have selections and UI properties
    const vs = this.viewStore;

    if (!selections || selections.length === 0) {
      return (
        <div className='coa'>
          You must have at least one Action.
        </div>
      )
    }

    return (
      <div className='coa' role="main" aria-label="Course of Action">
        <div className="introduction" dangerouslySetInnerHTML={{__html: introText}}></div>
        <div className='coa-content'>
          <div className='tabbed-panel'>
            <div className='tabs' role="navigation"
                 aria-label={`Course of Action: Choose one of ${selections.length} options`}>
              {selections.map((action, index) => {
                return <div
                  key={index}
                  className={'tab' + (index === visibleAction ? ' selected' : '')}
                  onClick={() => showAction(index)}
                  role="button"
                  aria-label={`Option ${index + 1}: ${action.title}.
                    ${index === selectedAction ? 'This option is selected' : ''}`}
                  tabIndex={vs.nextTabIndex}
                >
                  {index === selectedAction ? (<i className='fa fa-check' aria-label="Selected"></i>) : null}
                  <span dangerouslySetInnerHTML={{__html: action.title}}/>
                </div>
              })}
            </div>
            <div className='tab-contents'>
              {(visibleAction >= 0) &&
              <div className='tab-content'>
                <div className='heading'
                     dangerouslySetInnerHTML={{__html: selections[visibleAction].text}}></div>
                <div className='selected-tab'>
                  {selectedAction >= 0 && (<div className='selected-title' tabIndex={vs.nextSelectionTabIndex}><span
                    dangerouslySetInnerHTML={{__html: selections[selectedAction].title}}></span><span className='is-selected'>is selected</span>
                  </div>)}
                  {selectedAction < 0 && (<div className='selected-title'
                                               tabIndex={vs.nextSelectionTabIndex}>Select an action</div>)}
                  <div className='button'
                       onClick={selectAction}
                       role='button'
                       aria-labelledby={selections[selectedAction] ? selections[selectedAction].displayName : ''}
                       tabIndex={vs.nextSelectionTabIndex}>
                    Select&nbsp;<span
                                  id={selections[selectedAction] ? selections[selectedAction].displayName : ''}
                                  dangerouslySetInnerHTML={{__html: selections[visibleAction].title}}></span></div>
                </div>
              </div>
              }
            </div>
          </div>
          <div className='outcomes-panel'>
            <h3 className='outcomes-title'
                 dangerouslySetInnerHTML={{__html: criteriaTitle}}></h3>
            <div className='outcomes'>
              <div className='outcome'>
                {visibleAction >= 0 && selections[visibleAction].impacts.map((currentImpact, impactIndex) => {
                  return (<ImpactOptions impact={currentImpact} nextTabIndex={vs.nextTabIndex} key={currentImpact.id} />);
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class impactOptionsViewStore extends BaseViewStore {
  @computed get selectedValue() {
    const {
      impact,
    } = this.props;

    return impact.getInput('selectedValue');
  }

  @action.bound selectValue(value) {
    const {
      impact,
    } = this.props;

    impact.setInput('selectedValue', value);
    impact.saveInputs();
  }
}

@observer
class ImpactOptions extends BaseComponent {
  static ViewStore = impactOptionsViewStore;

  render() {
    const {
      impact,
      nextTabIndex,
      inputStore
    } = this.props;
    const {
      selectedValue,
      selectValue,
    } = this.viewStore;

    console.log(inputStore);

    return <div className='impact'>
      <h4 className='impact-title' aria-labeledby={impact.displayName}>
        <span id={impact.displayName} dangerouslySetInnerHTML={{__html: impact.text}}/>
      </h4>
      <div className='options'>
        {impact.options.map((option, optionIndex) => {
          return <div>
            <input type="radio"
                   name={impact.displayName}
                   value={option.value}
                   key={option.id}
                   id={`${option.displayName}_${optionIndex}`}
                   onChange={(e) => { selectValue(option.value); this.forceUpdate(); }}
                   checked={selectedValue === option.value}
                   tabIndex={nextTabIndex} />
            <label htmlFor={`${option.displayName}_${optionIndex}`}>{option.name}</label>
          </div>
        })}
      </div>
    </div>;
  }
}

export default CourseOfAction;



// WEBPACK FOOTER //
// ./app_modules/course-of-action-activity/src/component.js